import React, { useState, useEffect } from 'react'
import TreeView from '@material-ui/lab/TreeView'
import {
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box
} from '@material-ui/core'
import { ExpandMore, ChevronRight } from '@material-ui/icons'
import theme from '../../../theme/index'

import { getExternalLayers, MAP_ID } from '../../../utils/apiHelper'
import {
  useGlobalContext,
  accordionChange,
  externalTabChange
} from '../../../state'
import { IconMap } from '../../../utils/icons'
import { t } from '../../../utils/languages'

import { SelectedExternalLayers } from '../../SelectedExternalLayers'

import { useStyles } from '../styles'
import { ExternalLayer } from './ExternalLayer'

import {
  Button,
  Typography as TypographyGC
} from '@facility-latam/geoportal-components'

export const MenuExternalLayers = () => {
  const {
    state: { language, openAccordions, showSelectedExternalLayers },
    dispatch
  } = useGlobalContext()
  const classes = useStyles()
  const [tree, setTree] = useState([])

  useEffect(() => {
    setTree([])
    getExternalLayers()
      .then(({ categories, layers }) =>
        categories.map(({ idCategory, en, es }) => ({
          idCategory,
          categoryName: language !== 'en' ? es : en,
          layers: layers
            .filter(({ idCategory: id }) => id === idCategory)
            .map(
              ({ idLayer, description, layer, es: esLayer, en: enLayer }) => ({
                idLayer,
                layer,
                description,
                layerName: language !== 'en' ? esLayer : enLayer
              })
            )
        }))
      )
      .then((menu) => setTree(menu))
  }, [language])

  return (
    <>
      <Grid container columns={12}>
        <Grid item xs={6}>
          <Button
            isSelected={showSelectedExternalLayers}
            onClick={() => dispatch(externalTabChange(true))}
            color={showSelectedExternalLayers && theme.palette.primary.main}
          >
            <TypographyGC>{t('Capas Seleccionadas')}</TypographyGC>
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            isSelected={!showSelectedExternalLayers}
            onClick={() => dispatch(externalTabChange(false))}
          >
            <TypographyGC>{t('Datos geográficos')}</TypographyGC>
          </Button>
        </Grid>
      </Grid>
      {!showSelectedExternalLayers && (
        <Box className={classes.containerAccordion}>
          {!tree.length ? (
            <LinearProgress />
          ) : (
            tree.map(({ layers, idCategory, categoryName }) => (
              <Accordion
                key={idCategory}
                expanded={openAccordions.geo === idCategory}
              >
                <AccordionSummary
                  expandIcon={IconMap.get('DetailsOutlined')}
                  id={idCategory}
                  className="firstChildren"
                  onClick={() =>
                    dispatch(accordionChange({ id: idCategory, type: 'geo' }))
                  }
                >
                  <Box className={classes.boxIcon} />
                  <Typography>{categoryName}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TreeView
                    className={classes.root}
                    defaultCollapseIcon={<ExpandMore />}
                    defaultExpandIcon={<ChevronRight />}
                  >
                    {layers &&
                      layers.map(({ idLayer, layerName, layer }, index) => (
                        <ExternalLayer
                          key={index}
                          idLayer={idLayer}
                          name={layerName}
                          data={layer}
                        />
                      ))}
                  </TreeView>
                </AccordionDetails>
              </Accordion>
            ))
          )}
        </Box>
      )}
      <SelectedExternalLayers visibility={showSelectedExternalLayers} />
    </>
  )
}
